import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AlertError from 'components/error/alert-error/AlertError';

const UiDialogTitle = (props) => {
  const { children, className, error, ...restProps } = props;
  return (
    <>
      <DialogTitle
        className={classNames('ui-dialog-title', 'card-header', className)}
        {...restProps}
      >
        {children}
      </DialogTitle>
      {error && <AlertError error={error} />}
    </>
  );
};

UiDialogTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  error: PropTypes.object,
};

export default UiDialogTitle;
